import {FC} from "react";
import Table from "../../ui/Table";
import {nl2br} from "../../../helpers/humanSpaceState";
import {IToken} from "../../../types/ApiTypes";

interface Props {
  tokens: IToken[]
}

const TokenList: FC<Props> = (props) => {
  return (
    <Table.Skeleton>
      <Table.THead>
        <Table.HeadTR>
          <Table.TH>Id</Table.TH>
          <Table.TH>Token</Table.TH>
          <Table.TH>Name</Table.TH>
        </Table.HeadTR>
      </Table.THead>
      <Table.TBody>
        {props.tokens.length > 0 ? (
          props.tokens.map(x => (
            <Table.BodyTR key={x.id}>
              <Table.TD>{x.id}</Table.TD>
              <Table.TD>
                <span className='text-sm'>{x.token}</span>
              </Table.TD>
              <Table.TD>
                <span className='text-sm'>{x.name}</span>
              </Table.TD>
            </Table.BodyTR>
          ))
        ) : (
          <Table.BodyTR>
            <Table.TD colspan={2}>Keine Tokens verfügbar</Table.TD>
          </Table.BodyTR>
        )}
      </Table.TBody>
    </Table.Skeleton>
  );
};

export default TokenList;